module.exports = __webpack_public_path__ + "assets/webgl/Concrete_Wall_diffuse.558cfcb1.jpg";